import { version } from '../config';
import Loadable from 'react-loadable';
// import SPUListPage from '../pages/SPUListPage';
// import ProductClassPage from '../pages/ProductClassPage';
// import ProductClassChildPage from '../pages/ProductClassChildPage';
// import ProductClassThirdChildPage from '../pages/ProductClassThirdChildPage';
// import AttributeConfig from '../pages/AttributeConfigPage';
// import SPUAttributeList from '../pages/SPUAttributeListPage';
// import SKUAddPage from '../pages/SKUAddPage';
// import AttributeGroupList from '../pages/AttributeGroupList';
// import AttributeList from '../pages/AttributeList';
// import CategoryListPage from '../pages/CategoryListPage';
// import CategoryOptionsListPage from '../pages/CategoryOptionsListPage';
// import AddProductPage from '../pages/AddProductPage';
// import OptionList from '../pages/OptionList';
// import AddOptionPage from '../pages/AddOptionPage';
import Loading from '../components/Loading';
const productRoute = [
    //从吾学搬过来的商品模块
    {
        path: `/product/spu/${version}`,
        // component: SPUListPage,
        component: Loadable({ loader: () => import('../pages/SPUListPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '商品列表',
    },
    {
        path: `/product/productclass/${version}`,
        // component: ProductClassPage,
        component: Loadable({ loader: () => import('../pages/ProductClassPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '商品分类管理',
    },
    {
        path: `/product/productclass/child/${version}`,
        // component: ProductClassChildPage,
        component: Loadable({ loader: () => import('../pages/ProductClassChildPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '二级分类',
    },
    {
        path: `/product/productclass/child/third/${version}`,
        // component: ProductClassThirdChildPage,
        component: Loadable({ loader: () => import('../pages/ProductClassThirdChildPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '三级分类',
    },
    {
        path: `/product/spu/attrconfig/${version}`,
        // component: AttributeConfig,
        component: Loadable({ loader: () => import('../pages/AttributeConfigPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '商品规格属性管理',
    },
    {
        path: `/product/spu/spuattrconfig/${version}`,
        // component: SPUAttributeList,
        component: Loadable({ loader: () => import('../pages/SPUAttributeListPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '商品属性列表',
    },
    {
        path: `/product/spu/skuadd/${version}`,
        // component: SKUAddPage,
        component: Loadable({ loader: () => import('../pages/SKUAddPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '添加商品单品',
    },
    {
        path: `/product/attributegroup/${version}`,
        // component: AttributeGroupList,
        component: Loadable({ loader: () => import('../pages/AttributeGroupList'), loading: Loading }),
        strict: true,
        exact: true,
        title: '属性组列表',
    },
    {
        path: `/product/attributelist/${version}`,
        // component: AttributeList,
        component: Loadable({ loader: () => import('../pages/AttributeList'), loading: Loading }),
        strict: true,
        exact: true,
        title: '属性列表',
    },
    {
        path: `/product/categorylist/${version}`,
        // component: CategoryListPage,
        component: Loadable({ loader: () => import('../pages/CategoryListPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '类别列表',
    },
    {
        path: `/product/categorylist/add/${version}`,
        // component: CategoryOptionsListPage,
        component: Loadable({ loader: () => import('../pages/CategoryOptionsListPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '添加类别'
    },
    {
        path: `/product/spu/addProduct/${version}`,
        // component: AddProductPage,
        component: Loadable({ loader: () => import('../pages/AddProductPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '添加商品',
    },
    {
        path: `/course/list/edit/${version}`,
        // component: AddProductPage,
        component: Loadable({ loader: () => import('../pages/AddProductPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '添加课程',
    },
    {
        path: `/product/option/${version}`,
        // component: OptionList,
        component: Loadable({ loader: () => import('../pages/OptionList'), loading: Loading }),
        strict: true,
        exact: true,
        title: '选项管理',
    },
    {
        path: `/product/option/add/${version}`,
        // component: AddOptionPage,
        component: Loadable({ loader: () => import('../pages/AddOptionPage'), loading: Loading }),
        strict: true,
        exact: true,
        title: '添加选项',
    }
];

export default productRoute;


// WEBPACK FOOTER //
// ./src/routes/products.js